import React from "react";
import {Button, Row, Col} from "react-bootstrap";
import {useNavigate} from "react-router-dom";

const Back = () => {

    const navigate = useNavigate();

        return (
            <Row className={'mt-4 mt-lg-2'}>
                <Col>
                    <Button variant={'link'} onClick={() => navigate(-1)} className={'link-shape p-0'}>
                        <span>Torna indietro</span>
                    </Button>
                </Col>
            </Row>
        );

}

export default Back;